/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ClosedApplicationReasonEnum {
    NoCollateralInsufficient = 'NO_COLLATERAL_INSUFFICIENT',
    NoCollateralMortgage = 'NO_COLLATERAL_MORTGAGE',
    NoCollateralNotProvided = 'NO_COLLATERAL_NOT_PROVIDED',
    NoCollateralNoRealty = 'NO_COLLATERAL_NO_REALTY',
    NoCommunicationFromTheBeginning = 'NO_COMMUNICATION_FROM_THE_BEGINNING',
    NoCommunicationAfterTheOffer = 'NO_COMMUNICATION_AFTER_THE_OFFER',
    NoCommunicationDuringTheNegotiations = 'NO_COMMUNICATION_DURING_THE_NEGOTIATIONS',
    NoCommunicationAfterTheAftersale = 'NO_COMMUNICATION_AFTER_THE_AFTERSALE',
    InvalidContactAnotherPerson = 'INVALID_CONTACT_ANOTHER_PERSON',
    InvalidContactWrongNumber = 'INVALID_CONTACT_WRONG_NUMBER',
    UnknownPerson = 'UNKNOWN_PERSON',
    IdentityTheft = 'IDENTITY_THEFT',
    Spam = 'SPAM',
    NotInterestedOutdatedApplication = 'NOT_INTERESTED_OUTDATED_APPLICATION',
    NotInterestedRejectedOffer = 'NOT_INTERESTED_REJECTED_OFFER',
    NotInterestedOfferFromBank = 'NOT_INTERESTED_OFFER_FROM_BANK',
    InsufficientIncome = 'INSUFFICIENT_INCOME',
    Insolvency = 'INSOLVENCY',
    Duplicate = 'DUPLICATE',
    Competition = 'COMPETITION',
    MediatorNotInterested = 'MEDIATOR_NOT_INTERESTED',
    MediatorNotFound = 'MEDIATOR_NOT_FOUND',
    MediatorNoCommunication = 'MEDIATOR_NO_COMMUNICATION',
    ResoldNoCollateral = 'RESOLD_NO_COLLATERAL',
    ResoldNoCollateralNotProvided = 'RESOLD_NO_COLLATERAL_NOT_PROVIDED',
    ResoldOther = 'RESOLD_OTHER',
    Other = 'OTHER',
    Lost = 'LOST',
    ChangeDealType = 'CHANGE_DEAL_TYPE'
}

export function ClosedApplicationReasonEnumFromJSON(json: any): ClosedApplicationReasonEnum {
    return ClosedApplicationReasonEnumFromJSONTyped(json, false);
}

export function ClosedApplicationReasonEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClosedApplicationReasonEnum {
    return json as ClosedApplicationReasonEnum;
}

export function ClosedApplicationReasonEnumToJSON(value?: ClosedApplicationReasonEnum | null): any {
    return value as any;
}

